var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRulerToolIcon = function SvgRulerToolIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M5.657 22.243 1.414 18l16.97-16.97 4.243 4.242zm-4.95-3.536a1 1 0 0 1 0-1.414L17.677.323a1 1 0 0 1 1.415 0l4.243 4.242a1 1 0 0 1 0 1.414L6.363 22.95a1 1 0 0 1-1.414 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.942 15.238a.5.5 0 0 1-.707.707zM5.174 13.47l1.768 1.768-.707.707-1.768-1.768zM11.895 10.287a.5.5 0 0 1-.707.707zM10.127 8.52l1.768 1.768-.707.707L9.42 9.227zM16.84 5.338a.5.5 0 0 1-.707.707zM15.072 3.57l1.768 1.768-.707.707-1.768-1.768z"
  })));
};
export default SvgRulerToolIcon;